var _ = require('optimizely-client-fn');

/**
 * Get descriptive string for a group (for logging)
 * @param {Group} group
 * @returns {string}
 */
exports.description = function(group:Group): string {
  var hasName = !!group.name;
  var name = hasName ? ('"' + group.name + '" ') : '';
  var layerIds = getGroupLayerIds(group).join(', ');

  return name + '(id ' + group.id + ', campaigns: ' + layerIds + ')';
};

/**
 * @param {Group} group
 * @return {string[]} Layer IDs in the group
 */
function getGroupLayerIds(group:Group): string[] {
  return _.map(group.weightDistributions, 'entityId');
}
